import { render, staticRenderFns } from "./monthlyRefunds.vue?vue&type=template&id=3c34594c"
import script from "./monthlyRefunds.vue?vue&type=script&lang=js"
export * from "./monthlyRefunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports